import commonHeader from '../components/mtHeader'
import sideBar from '../components/sideBar'
import sideBarLine from '../components/sideBarLine'
import pageTop from '../components/pageTop'
import measureTab from '../components/measureTab'
import construcPic from '../components/construcPic'
import pay from '../components/pay'
import noData from '../components/noData'
export default {
  install(Vue){
    // 时间格式转化2020-11-22 16:40
    Vue.prototype.formatDate=function(date,type=true){
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds()
      return type?[year,month,day].map(this.formatNumber).join('-')+' '+[hour,minute].map(this.formatNumber).join(':'):[year,month,day].map(this.formatNumber).join('-')+' '+[hour,minute,second].map(this.formatNumber).join(':');
    }
    Vue.prototype.formatNumber = n => {
      n = n.toString();
      return n[1] ? n : '0' + n;
    }
    Vue.component(commonHeader.name,commonHeader);
    Vue.component(sideBar.name,sideBar);
    Vue.component(sideBarLine.name,sideBarLine);
    Vue.component(pageTop.name,pageTop);
    Vue.component(measureTab.name,measureTab);
    Vue.component(construcPic.name,construcPic);
    Vue.component(pay.name,pay);
    Vue.component(noData.name,noData);
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js